const deleteChecklistBySiteStr = {
  toastr: 'The checklist has been deleted!'
};

export default deleteChecklistBySiteStr;
